var _a;
/**
 * @hidden
 */
export var noData = 'sortable.noData';
/**
 * @hidden
 */
export var messages = (_a = {},
    _a[noData] = 'No Data',
    _a);
//# sourceMappingURL=index.js.map